export default __webpack_public_path__ + "static/media/socalAreaMap.40df5184.png";